export default __webpack_public_path__ + "static/media/07-get-updated.5306444a.jpg";